import { Link } from "react-router-dom";
import { Phone, MapPin, Mail } from "lucide-react";
import { BUSINESS, ASSETS } from "@/data";

const NAV = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Projects", to: "/projects" },
  { label: "Contact", to: "/contact" },
];

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-charcoal border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src={ASSETS.logo} alt="L3 Construction" className="h-14 w-14 object-contain" />
            <div className="leading-none">
              <div className="font-display text-2xl" style={{ color: "var(--l3-cream)" }}>L3 CONSTRUCTION</div>
              <div className="font-cond text-[10px] tracking-[0.35em] text-gold">HOMEBUILDING</div>
            </div>
          </div>
          <p className="text-sm text-white/60 max-w-xs leading-relaxed">
            Building homes and building trust across Northern Nevada — backed by owners with over {BUSINESS.experienceYears} years of combined experience.
          </p>
        </div>

        <div className="font-cond">
          <h4 className="text-gold tracking-widest text-sm mb-4">EXPLORE</h4>
          <ul className="space-y-2.5 text-white/75 text-sm">
            {NAV.map((n) => (
              <li key={n.label}>
                <Link to={n.to} data-testid={`footer-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`} className="hover:text-gold transition-colors">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="font-cond">
          <h4 className="text-gold tracking-widest text-sm mb-4">GET IN TOUCH</h4>
          <ul className="space-y-3 text-white/75 text-sm">
            <li>
              <a href={BUSINESS.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 hover:text-gold transition-colors">
                <Phone size={16} className="text-gold" /> {BUSINESS.phone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="text-gold mt-1" />
              <span className="flex flex-col">
                {BUSINESS.emails.map((em) => (
                  <a key={em} href={`mailto:${em}`} className="hover:text-gold transition-colors">{em}</a>
                ))}
              </span>
            </li>
            <li className="flex items-center gap-3">
              <MapPin size={16} className="text-gold" /> {BUSINESS.serviceArea}
            </li>
          </ul>
        </div>

        <div className="font-cond">
          <h4 className="text-gold tracking-widest text-sm mb-4">SERVICE AREA</h4>
          <p className="text-white/75 text-sm leading-relaxed">
            Proudly serving Reno, Sparks, Carson City and all of Northern Nevada.
          </p>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-white/40 text-xs tracking-wide font-cond">
        © {new Date().getFullYear()} L3 CONSTRUCTION HOMEBUILDING. BUILT WITH INTEGRITY.
      </div>
    </footer>
  );
}
